var _excluded = ["openingMessage", "errorTitle", "titularElementTag", "errorMessage", "signupButtonProps", "linksProps", "showLinks", "data-testid"];
var _jsxFileName = "/home/runner/_work/smpackages/smpackages/packages/webassets/src/components/FourHundredError/FourHundredError.tsx",
  _this = this;
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { Box } from '@wds/box';
import { t, defineMessages } from '@sm/intl';
import { withWebAssetsTheme } from '../../theme';
import { ClientError } from '../ClientError';
import SignupButton from '../ClientError/SignupButton';
import Links from '../ClientError/Links';
var COPY = defineMessages({
  SORRY_MESSAGE: {
    id: 'FourHundredError.sorryMessage',
    defaultMessage: "We're sorry",
    description: '[Type: Label][Vis.: med] - We are sorry message'
  },
  CANT_FIND_PAGE: {
    id: 'FourHundredError.cantFindPage',
    defaultMessage: "We can't find the page you're looking for.",
    description: '[Type: Label][Vis.: med] - Cant find page message'
  },
  CHECK_URL: {
    id: 'FourHundredError.checkURL',
    defaultMessage: "Please check the URL you entered to make sure it's spelled correctly.",
    description: '[Type: Label][Vis.: med] - check URL subtitle'
  },
  HELP_FIND_WAY: {
    id: 'FourHundredError.helpFindWay',
    defaultMessage: 'Still not sure how to get to the page you want? Maybe we can help you find your way:',
    description: '[Type: Label][Vis.: med] - Help find your way subtitle'
  }
});
var FourHundredError = function FourHundredError(_ref) {
  var _ref$openingMessage = _ref.openingMessage,
    openingMessage = _ref$openingMessage === void 0 ? t(COPY.SORRY_MESSAGE) : _ref$openingMessage,
    _ref$errorTitle = _ref.errorTitle,
    errorTitle = _ref$errorTitle === void 0 ? t(COPY.CANT_FIND_PAGE) : _ref$errorTitle,
    _ref$titularElementTa = _ref.titularElementTag,
    titularElementTag = _ref$titularElementTa === void 0 ? 'p' : _ref$titularElementTa,
    _ref$errorMessage = _ref.errorMessage,
    errorMessage = _ref$errorMessage === void 0 ? [t(COPY.CHECK_URL), t(COPY.HELP_FIND_WAY)] : _ref$errorMessage,
    signupButtonProps = _ref.signupButtonProps,
    linksProps = _ref.linksProps,
    _ref$showLinks = _ref.showLinks,
    showLinks = _ref$showLinks === void 0 ? false : _ref$showLinks,
    _ref$dataTestid = _ref['data-testid'],
    dataTestId = _ref$dataTestid === void 0 ? 'FourHundredError' : _ref$dataTestid,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(ClientError, Object.assign({
    openingMessage: openingMessage,
    errorTitle: errorTitle,
    titularElementTag: titularElementTag,
    "data-testid": dataTestId
  }, props, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(Box, {
    mt: 4,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 60,
      columnNumber: 7
    }
  }, React.Children.map(errorMessage, function (message) {
    return /*#__PURE__*/React.createElement("p", {
      "data-testid": "".concat(dataTestId, "_ErrorMessage"),
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 62,
        columnNumber: 11
      }
    }, message);
  })), /*#__PURE__*/React.createElement(SignupButton, Object.assign({}, signupButtonProps, {
    mt: 5,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 65,
      columnNumber: 7
    }
  })), showLinks && /*#__PURE__*/React.createElement(Links, Object.assign({}, linksProps, {
    mt: 6,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 66,
      columnNumber: 21
    }
  })));
};
export default withWebAssetsTheme(FourHundredError);
//# sourceMappingURL=FourHundredError.js.map